import {
    instance as axios,
    setJwtToken,
    setMultiPartHeader,
  } from "../../config/axiosInstance";
  
export const recipeListApi = async (data) => {
  const endPoint = `admin/recipe/list?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};
  
export const recipeDetailApi = async (data) => {
  const endPoint = `admin/recipe?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};

export const addRecipeApi = async (data) => {
    const endPoint = `admin/recipe`;
    return await axios.post(endPoint, data, setMultiPartHeader());
};

export const updateRecipeApi = async (data) => {
    const endPoint = `admin/recipe`;
    return await axios.put(endPoint, data, setMultiPartHeader());
};

export const deleteRecipeApi = async (data) => {
  const endPoint = `admin/recipe?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.delete(endPoint, setJwtToken());
};



export const recipeCollectionListApi = async (data) => {
    const endPoint = `admin/recipe-collection/list?${new URLSearchParams(
      data
    ).toString()}`;
    return await axios.get(endPoint, setJwtToken());
  };
    
  export const recipeCollectionDetailApi = async (data) => {
    const endPoint = `admin/recipe-collection?${new URLSearchParams(
      data
    ).toString()}`;
    return await axios.get(endPoint, setJwtToken());
  };
  
  export const addRecipeCollectionApi = async (data) => {
      const endPoint = `admin/recipe-collection`;
      return await axios.post(endPoint, data, setMultiPartHeader());
  };
  
  export const updateRecipeCollectionApi = async (data) => {
      const endPoint = `admin/recipe-collection`;
      return await axios.put(endPoint, data, setMultiPartHeader());
  };
  
  export const deleteRecipeCollectionApi = async (data) => {
    const endPoint = `admin/recipe-collection?${new URLSearchParams(
      data
    ).toString()}`;
    return await axios.delete(endPoint, setJwtToken());
  };